import { useState } from 'react';
import JSONPretty from "react-json-pretty";
import "react-json-pretty/themes/monikai.css";

import { execSeatableSql } from './seatable.js';

function Query() {
  const [sql, setSql] = useState('SELECT * FROM Capability');
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(false);

  async function fetchData() {
    setRows(null);
    setLoading(true);
    try {
      const data = await execSeatableSql(sql);
      setRows(data);
    } catch (err) {
      setRows(err);
    } finally {
      setLoading(false);
    }
  }

  if (loading) return <div>Loading...</div>

  return <>
    <div className="nav-buffer"></div>
    <div className="w-100 mt-5">
      <form style={{width: "100%", display: "flex", justifyContent: "center"}} onSubmit={fetchData}>
        <input style={{width: "66%"}} type="text" value={sql} onChange={(e) => setSql(e.target.value)} />
        <button style={{marginLeft: "5px"}} type="submit">Run</button>
      </form>
    </div>
    {rows ? (
      <div>
        <h3>{`Result - ${rows && rows.results ? rows.results.length : 0} rows`}</h3>
        <JSONPretty data={rows}></JSONPretty>
      </div>
    ) : ''}
  </>
}

export default Query;